import React from 'react';
import { Helmet } from 'react-helmet';
import './pagestyles/Businessweek.css';
import BottomBanner from './BottomBanner';

const Businessweek = () => {
  return (
    <>
      <Helmet>
        <title>Businessweek - In-Depth Business Analysis | Redbox Global</title>
        <meta name="description" content="Exclusive business features and analysis covering AI transformation, CEO strategies, startup innovation, and leadership insights from RedBox Global Magazine." />
        <meta name="keywords" content="business magazine, businessweek, business analysis, CEO strategies, AI in business, startup innovation, leadership, business trends, corporate strategy" />
        
        {/* Open Graph / Facebook */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://redboxglobal.com/businessweek" />
        <meta property="og:title" content="Businessweek - In-Depth Business Analysis | Redbox Global" />
        <meta property="og:description" content="Exclusive business features covering AI transformation, CEO strategies, and startup innovation." />
        <meta property="og:image" content="https://images.unsplash.com/photo-1504711434969-e33886168f5c?w=1200&h=630&fit=crop" />
        
        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:url" content="https://redboxglobal.com/businessweek" />
        <meta name="twitter:title" content="Businessweek - In-Depth Business Analysis | Redbox Global" />
        <meta name="twitter:description" content="Exclusive business features covering AI transformation, CEO strategies, and startup innovation." />
        <meta name="twitter:image" content="https://images.unsplash.com/photo-1504711434969-e33886168f5c?w=1200&h=630&fit=crop" />
        
        {/* Additional SEO */}
        <meta name="robots" content="index, follow" />
        <meta name="author" content="Redbox Global" />
        <link rel="canonical" href="https://redboxglobal.com/businessweek" />
      </Helmet>
      
      <div className="page-container">
      <div className="page-header">
        <h1>Businessweek</h1>
        <p className="page-subtitle">In-depth features and analysis from RedBox Global Magazine</p>
      </div>
      
      <div className="page-content">
        <a href="/article/future-of-work-ai-reshaping-business" style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}>
          <div className="featured-article">
            <div className="featured-image">
              <img src="https://images.unsplash.com/photo-1504711434969-e33886168f5c?w=1200&h=600&fit=crop" alt="Business magazine feature" />
            </div>
            <div className="featured-content">
             
              <h2>The Future of Work: How AI is Reshaping Business</h2>
              <p>An in-depth look at how artificial intelligence is transforming the workplace, changing job roles, and creating new opportunities for businesses and workers alike.</p>
              <span className="article-meta">This Week's Feature</span>
            </div>
          </div>
        </a>

        <div className="content-grid">
          <a href="/article/ceo-strategies-2026" style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}>
            <article className="article-card">
              <div className="article-image">
                <img src="https://images.unsplash.com/photo-1552664730-d307ca884978?w=600&h=400&fit=crop" alt="Leadership" />
              </div>
              <div className="article-content">
                
                <h2>CEO Strategies for 2026</h2>
                <p>Top executives share their vision and strategies for navigating an uncertain business landscape.</p>
                <span className="article-meta">January 14, 2026</span>
              </div>
            </article>
          </a>

          <a href="/article/startups-disrupting-industries" style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}>
            <article className="article-card">
              <div className="article-image">
                <img src="https://images.unsplash.com/photo-1559136555-9303baea8ebd?w=600&h=400&fit=crop" alt="Innovation" />
              </div>
              <div className="article-content">
                
                <h2>Startups Disrupting Traditional Industries</h2>
                <p>How young companies are challenging established players with innovative business models.</p>
                <span className="article-meta">January 13, 2026</span>
              </div>
            </article>
          </a>
        </div>
      </div>
    </div>
    
      <BottomBanner />
        </>
  );
};

export default Businessweek;
